import styled from 'styled-components';

export const StyledFsMigrationBanner = styled.div`
  height: 48px;
  width: 100%;
  background-color: #e0f0fd;
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 700;

  .banner-icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }

  .banner-text {
    font-weight: 700;
  }

  .banner-button-as-link {
    background: none;
    border: none;
    color: #2e66d0;
    cursor: pointer;
    padding-left: 8px;
  }
`;

export const ConfirmationDialogContent = styled.div`
  margin: 16px 0 0;
  width: 761px;
  font-size: 14px;
  line-height: 1.5;

  .banner-modal-header {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 4px;
  }

  .banner-modal-description {
    margin: 0;
  }

  .banner-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    padding: 0 116px;
    row-gap: 24px;

    .banner-modal-actions-header {
      font-size: 14px;
      margin-bottom: 0px;
    }

    .migration-links {
      display: flex;
      column-gap: 48px;

      .migration-link-item {
        list-style: none;

        .migration-link {
          height: 100%;
          min-width: 240px;
          background-color: #e0f0fd;
          border-radius: 8px;
          display: block;
          padding: 8px 12px 34px 12px;
          border: 2px solid transparent;
          .migration-link-header {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
          }
          .migration-link-description {
            font-size: 12px;
            margin: 0px;
          }
          &:hover {
            border-color: #2e66d0;
            color: initial;
          }
        }
      }
    }
    .banner-modal-export {
      padding: 8px 24px;
      border: 1px solid #c1e2ff;
      border-radius: 8px;
      font-size: 12px;
      cursor: pointer;
      width: 100%;

      .banner-modal-actions-header {
        font-weight: 600;
        margin-bottom: 4px;
      }

      &:hover {
        box-shadow: 2px 2px 8px -2px #12334c0d;
      }
    }
  }
`;
